import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Box, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import BookingStoreContext from "../../store/context";
import { useStores } from "../../../../../../hooks";
import { Centered, Divider, Space, Typography } from "../../../../../../common/components/libs";
import ChooseMenu from "./components/ChooseMenu";
import { FadeInOutVertical } from "../../../../../../common/components/Animated";
import FilterForTable from "./components/table/FilterForTable";
import FilterForCard from "./components/card/FilterForCard";
import NoBookings from "./components/NoBookings";
import OrderCard from "./components/card/OrderCard";
import OrdersTable from "./components/table/OrdersTable";




const BookingsList = () => {
    const { generalStore } = useStores();
    const bookingsStore = useContext(BookingStoreContext);
    const { list } = bookingsStore;
    const { i18n, t, ready } = useTranslation(["bookings"], { useSuspense: false });

    const filter = bookingsStore.filter;

    useEffect(() => {
        bookingsStore.init();
        generalStore.setPageTitle("");

    }, [ready]);

    useEffect(() => {
        bookingsStore.getBookings({
            ...filter
        });
    }, [bookingsStore.filter]);


    if (!list) return null;

    const bookings = list.slice().reverse();


    return <>
        <Helmet title={t("bookings:title")}/>
        <Grid justify="space-between" alignItems='center' container spacing={8}>
            <Grid item>
                <Typography variant="h3" ml={2}>
                    {t("bookings:infoShortTitle")}
                </Typography>
            </Grid>
            <Grid item>
                <ChooseMenu/>
            </Grid>
        </Grid>
        <Divider my={6}/>
        <Grid container spacing={6}>
            <Grid item xs={12} style={{ marginBottom: "150px" }}>
                <FadeInOutVertical show={true}>
                    <div>
                        <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                            <FilterForTable/>
                        </Box>
                        <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                            <FilterForCard/>
                        </Box>
                        {bookings.length === 0 &&
							<Centered>
								<NoBookings/>
							</Centered>
                        }
                        {bookings.length > 0 &&
							<Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
								<OrdersTable orders={bookings}/>
							</Box>
                        }
                        {bookings.length > 0 &&
							<Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                                {bookings.map((order) => {
                                    return (
                                        <>
                                            <OrderCard order={order}/>
                                            <Space size={10}/>
                                        </>
                                    );
                                })}
							</Box>
                        }
                    </div>
                </FadeInOutVertical>
            </Grid>
        </Grid>

    </>;
};


export default observer(BookingsList);
